import React, { useState, useEffect } from "react";
import * as moment from "moment";

import cardicon from "../../../../../assets/card-icon.svg";
import savestfundfrombank from "../../../../../assets/savestfundfrombank.svg";
import paymentmethod from "../../../../../assets/Payment System Logo.svg";

import { $api } from "../../../../../../../../helpers/$api";
import { Util } from "../../../../../../../../helpers/util";
import { PaymentMethodCard } from "../../../../../../../shared/payment-method-card/payment-method-card";

const FixedPayment = ({ setChange, goBackTo }) => {
  const { currency } = Util.getCurrency();

  const [ovest, setOvest] = useState("0");
  const [dollar, setDollar] = useState("0");
  const [cards, setCards] = useState([]);
  const [showCard, setShowCard] = useState( false );
  

  const handlePaymentmethodClick = (payment_method, card_id, meta = {}) => {
    setChange(goBackTo, { payment_method, card_id, ovest, dollar, meta });
  };

  useEffect(() => {
    (async () => {
      try {
        const { wallet_balance: ovest, dollar_wallet } =
          await $api.user.getBalances();
        const cards = await $api.user.getUserCards();

        setCards(cards);
        setOvest(ovest);
        setDollar(dollar_wallet);
      } catch (error) {
        // error...
      }
    })();
  }, [setOvest, setCards, setDollar]);

  return (
    <div className="startinvestment-body">
      <div className="startinvestment-main">
        <div className="paymentmethod-main">
          <h5 className="paymentmethod-header">Payment Method</h5>

          <div
            className="payment-cards"
            onClick={() => handlePaymentmethodClick("ovest_wallet")}
          >
            <PaymentMethodCard
              icon={cardicon}
              name={"OVest Wallet"}
              balance={`${currency}${Util.formatMoneyNumber(ovest)}`}
            />
          </div>
          {+dollar !== 0 && (
            <div
              className="payment-cards"
              onClick={() => handlePaymentmethodClick("dollar_wallet")}
            >
              <PaymentMethodCard
                icon={cardicon}
                name={"OVest Dollar Wallet"}
                balance={`$${Util.formatMoneyNumber(dollar)}`}
              />
            </div>
          )}

          <div
            className="payment-cards"
            onClick={() => {
              setShowCard(true);
            }}
          >
            <PaymentMethodCard
              icon={savestfundfrombank}
              name={"Fund from bank"}
            />
          </div>

          {/* Card Method */}
          {showCard && (
            <div>
              <div className="select-cards">
                <p className="select-cards-p">Select Cards</p>
              </div>

              {cards.map((card) => {
                const [, last_four] = card.card.split("*****");

                return (
                  <>
                    <div className="card-selection" key={card.id}>
                      <div className="payment-radio">
                        <input
                          type="radio"
                          id="html"
                          name="fav_language"
                          value="HTML"
                          onClick={() => {
                            handlePaymentmethodClick("card", card.id, {
                              last_four,
                              name: `${card.firstname} ${card.lastname}`,
                            });
                          }}
                        />
                      </div>
                      <div className="payment-bank">
                        <p className="payment-bank-p1">
                          Ending in: **** {last_four}
                        </p>
                        <p className="payment-bank-p2">
                          {card.firstname} {card.lastname}
                        </p>
                        <p className="payment-bank-p3">
                          Last time used:{" "}
                          {moment(card.updated_at).format("ddd MMM DD, YYYY")}
                        </p>
                      </div>
                      <div className="payment-method-img">
                        <img src={paymentmethod} alt="" />
                      </div>
                    </div>
                    <hr />
                  </>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FixedPayment;
